import Premium from "../subscriptions/index.js"

export default Premium



// WEBPACK FOOTER //
// ./src/enterprise/index.js